import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpHelpService } from 'src/app/Data/service/http-help.service';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { companyLabelHeEnAr } from 'src/app/components/alldocuments/alldocuments-companies/companies.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit, OnDestroy {
  /** When false, ignore `openHeaderCompanySelect` (used when a second instance is on a page). */
  @Input() listenForOpenEvent = true;

  curentLang:string="";
  public openCart: boolean = false;
  allActivecompanyData:any;
  companyId:any;
  selectedCompanyId: number | null = null;
  selectedCompanyLogo: string | null = null;
  companyNameAr: string | null = null;
  companyNameEn: string | null = null;
  companyNameHe: string | null = null;

  userRegistId:any = JSON.parse(localStorage.getItem('user_id') || 'null');
  private destroy$ = new Subject<void>();
  private openHeaderCompanySelectHandler?: (event: any) => void;
  private companiesUpdatedHandler?: (event: any) => void;

  constructor(
    private service: HttpHelpService, 
    private spinner: NgxSpinnerService,
    private router: Router,
    private translate: TranslateService
  ) 
  {
    this.curentLang = localStorage.getItem('curentLang') || 'en';
  }
  GetCompany() 
{
    this.service.GetCompany().subscribe(res => {
      // Safety filter: never show archived companies in the header selector
      this.allActivecompanyData = (res || []).filter(
        (c: any) => c.company_status !== 'ARCHIVED'
      );
      
      // Ensure selected company is properly set after companies load
      const storedCompanyId = localStorage.getItem('companyDefault');
      if (storedCompanyId) {
        const companyId = Number(storedCompanyId);
        // Verify the stored company exists in the active companies list
        const companyExists = this.allActivecompanyData?.some((c: any) => c.company_id === companyId);
        if (companyExists) {
          this.selectedCompanyId = companyId;
          // Update logo from the company data if available
          this.updateSelectedCompanyLogo();
        } else {
          // Stored company is no longer in active list (e.g. was archived) — clear it
          this.selectedCompanyId = null;
          localStorage.removeItem('companyDefault');
          localStorage.removeItem('selectedCompanyLogo');
          this.selectedCompanyLogo = null;
          // Clear displayed company name
          this.companyNameAr = null;
          this.companyNameEn = null;
          this.companyNameHe = null;
          localStorage.removeItem('company_name_ar');
          localStorage.removeItem('company_name_en');
          localStorage.removeItem('company_name_he');
          // Auto-select the first available active company
          if (this.allActivecompanyData?.length > 0) {
            const first = this.allActivecompanyData[0];
            this.selectedCompanyId = first.company_id;
            localStorage.setItem('companyDefault', String(first.company_id));
            this.updateSelectedCompanyLogo();
          }
        }
      } else if (this.selectedCompanyId) {
        // If we have a selectedCompanyId but it's not in localStorage, update logo
        this.updateSelectedCompanyLogo();
      } else {
        // No company selected at all — auto-select the first active company
        if (this.allActivecompanyData?.length > 0) {
          const first = this.allActivecompanyData[0];
          this.selectedCompanyId = first.company_id;
          localStorage.setItem('companyDefault', String(first.company_id));
          this.updateSelectedCompanyLogo();
        }
      }
    })
  };

  getCompanyId(id: number): void {
    this.selectedCompanyId = id;
    localStorage.setItem('companyDefault', id.toString());
    this.updateSelectedCompanyLogo();
    
    // Close the dialog after selection
    this.openCart = false;
    
    // Get the full company data to check if it has companyType
    const selectedCompany = this.allActivecompanyData.find(company => company.company_id === id);
// Emit a custom event to notify alldocuments component about company change
    const companyChangeEvent = new CustomEvent('companyChanged', {
      detail: { companyId: id }
    });
    window.dispatchEvent(companyChangeEvent);
  }

  /**
   * Select company and close dialog
   */
  selectCompany(company: any): void {
    this.getCompanyId(company.company_id);
    this.setCompanyDefault(null);
  }

  /**
   * Handle dialog close
   */
  onDialogClose(): void {
    this.openCart = false;
  }

  /**
   * Scroll to selected company when dialog opens
   */
  scrollToSelectedCompany(): void {
    if (this.selectedCompanyId && this.allActivecompanyData) {
      // Use setTimeout to ensure DOM is rendered
      setTimeout(() => {
        const selectedElement = document.querySelector('.company-item--active');
        if (selectedElement) {
          selectedElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }, 100);
    }
  }

  setCompanyDefault(  company_default:any){
    this.spinner.show();
  
    let model =
    {
      "company_default": this.selectedCompanyId  ,
     "updated_by": this.userRegistId
    }
  
    this.service.setCompanyDefault(  model ).subscribe(({
      
      next:res =>{
       if (res.status ==200){

        // Swal.fire({
        //   icon: 'success',
        //   // title: this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe),
        // })
          this.GetCompany();
          this.spinner.hide();
          window.location.reload();

       }
  
      },
      error:err =>{
        Swal.fire({
          icon:"error",
          title:err.error.message[0]
        });
        this.spinner.hide();
  
      }
      
    }))
  };

  ngOnInit() {
    const userIdStr = localStorage.getItem('user_id');
    this.userRegistId = userIdStr ? JSON.parse(userIdStr) : null;

    // Load selected company from localStorage (even if no logo stored)
    const storedCompanyId = localStorage.getItem('companyDefault');
    const storedCompanyLogo = localStorage.getItem('selectedCompanyLogo');
    
    // Load company names from localStorage
    this.companyNameAr = localStorage.getItem('company_name_ar');
    this.companyNameEn = localStorage.getItem('company_name_en');
    this.companyNameHe = localStorage.getItem('company_name_he');
    
    if (storedCompanyId) {
      this.selectedCompanyId = Number(storedCompanyId);
      if (storedCompanyLogo) {
        this.selectedCompanyLogo = storedCompanyLogo;
      }
    }

    // Load companies (will verify and update selected company after load)
    this.GetCompany();
    
    // Subscribe to language changes to update company name display
    this.translate.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe((event) => {
        this.curentLang = event.lang;
      });
    
            // Listen for route changes - close dialog when navigating away
            this.router.events
              .pipe(
                filter(event => event instanceof NavigationEnd),
                takeUntil(this.destroy$)
              )
              .subscribe((event: NavigationEnd) => {
                // Always close dialog on route change to prevent flickering
                // User can manually open it if needed
                if (this.openCart) {
                  this.openCart = false;
                }
              });

            // Listen for openHeaderCompanySelect event from New Document button
            if (this.listenForOpenEvent) {
              this.openHeaderCompanySelectHandler = (event: any) => {
                // Use setTimeout to prevent conflicts with route changes
                setTimeout(() => {
                  this.openCart = true;
                }, 100);
              };
              window.addEventListener('openHeaderCompanySelect', this.openHeaderCompanySelectHandler);
            }

            // Refresh the company list when a company is archived or restored
            this.companiesUpdatedHandler = (event: any) => {
              const archivedId = event?.detail?.archivedId;
              if (archivedId) {
                // Immediately remove archived company from the list (no API round-trip needed)
                this.allActivecompanyData = (this.allActivecompanyData || []).filter(
                  (c: any) => c.company_id !== +archivedId
                );
                // If the currently selected company was archived, clear it and auto-select
                if (this.selectedCompanyId === +archivedId) {
                  this.selectedCompanyId = null;
                  this.selectedCompanyLogo = null;
                  this.companyNameAr = null;
                  this.companyNameEn = null;
                  this.companyNameHe = null;
                  localStorage.removeItem('companyDefault');
                  localStorage.removeItem('selectedCompanyLogo');
                  localStorage.removeItem('company_name_ar');
                  localStorage.removeItem('company_name_en');
                  localStorage.removeItem('company_name_he');
                  if (this.allActivecompanyData?.length > 0) {
                    const first = this.allActivecompanyData[0];
                    this.selectedCompanyId = first.company_id;
                    localStorage.setItem('companyDefault', String(first.company_id));
                    this.updateSelectedCompanyLogo();
                  }
                }
              }
              // Also do a full API refresh to sync any other changes
              this.GetCompany();
            };
            window.addEventListener('companiesUpdated', this.companiesUpdatedHandler);
  }

  updateSelectedCompanyLogo(): void {
    const selectedCompany = this.allActivecompanyData.find(company => company.company_id === this.selectedCompanyId);
    if (selectedCompany) {
      this.selectedCompanyLogo = selectedCompany.logo_url || null;
      if (selectedCompany.logo_url) {
        localStorage.setItem('selectedCompanyLogo', selectedCompany.logo_url);
      } else {
        localStorage.removeItem('selectedCompanyLogo');
      }

     
        // Set the company names
        this.companyNameAr = selectedCompany.company_name_ar;
        this.companyNameEn = selectedCompany.company_name_en;
        this.companyNameHe = selectedCompany.company_name_he;
    
       
        if (this.companyNameAr) localStorage.setItem('company_name_ar', this.companyNameAr);
        if (this.companyNameEn) localStorage.setItem('company_name_en', this.companyNameEn);
        if (this.companyNameHe) localStorage.setItem('company_name_he', this.companyNameHe);
  
    
    
    } else {
      this.selectedCompanyLogo = null;
      localStorage.removeItem('selectedCompanyLogo');
    }
  }

  /**
   * Get company initials for display when logo is not available
   */
  getCompanyInitials(company: any): string {
    const name = companyLabelHeEnAr(company);

    if (!name) return '?';
    
    const words = name.trim().split(/\s+/);
    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  }

  /**
   * Display name: Hebrew if present, else English, else Arabic (same as company list).
   */
  getCurrentCompanyName(): string {
    return companyLabelHeEnAr({
      company_name_he: this.companyNameHe ?? undefined,
      company_name_en: this.companyNameEn ?? undefined,
      company_name_ar: this.companyNameAr ?? undefined,
    });
  }

  /** HE → EN → AR for a row from GetCompany(). */
  getCompanyDisplayName(company: any): string {
    return companyLabelHeEnAr(company);
  }

  /**
   * Check if company has a valid logo URL
   */
  hasValidLogo(logoUrl: string | null | undefined): boolean {
    return !!(logoUrl && typeof logoUrl === 'string' && logoUrl.trim() !== '' && logoUrl !== 'null' && logoUrl !== 'undefined');
  }

  /**
   * Handle image load error
   */
  onImageError(event: any): void {
    const img = event.target;
    img.style.display = 'none';
    
    // Find the fallback element (sibling or parent's child)
    const fallback = img.nextElementSibling || 
                     img.parentElement?.querySelector('.company-logo-fallback') ||
                     img.parentElement?.querySelector('.company-logo-fallback-item');
    
    if (fallback) {
      fallback.style.display = 'flex';
    }
  }
  // For Mobile Device
  toggleCart() {
    this.openCart = !this.openCart;
    // Scroll to selected company when opening
    if (this.openCart) {
      this.scrollToSelectedCompany();
    }
  }

  ngOnDestroy(): void {
    // Remove event listeners to prevent memory leaks
    if (this.openHeaderCompanySelectHandler) {
      window.removeEventListener('openHeaderCompanySelect', this.openHeaderCompanySelectHandler);
    }
    if (this.companiesUpdatedHandler) {
      window.removeEventListener('companiesUpdated', this.companiesUpdatedHandler);
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

}
